import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemPrefix,
    Accordion,
    AccordionHeader,
    AccordionBody,
} from "@material-tailwind/react";
import {
    CodeBracketIcon,
} from "@heroicons/react/24/solid";
import {
    ChevronDownIcon,
    KeyIcon,
    DocumentCheckIcon,
    MapPinIcon,
    GlobeAltIcon,
    BookOpenIcon,
    WrenchScrewdriverIcon,
    AcademicCapIcon,
    DocumentTextIcon,
    CubeIcon,
    CircleStackIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';
import apiLogo from "../img/api/apiLogo.png";

export const CustomSidebar = () => {
   
    const [open, setOpen] = useState(0);
    const { t } = useTranslation();

    const handleOpen = (value) => {
        setOpen(open === value ? 0 : value);
    };

    return (
        <Card className="flex flex-grow min-h-[90vh] w-full max-w-[20rem] p-4 shadow-xl shadow-blue-gray-900/5">
            <Link to="/osiris-api/" key="/osiris-api/">
                <div className="mb-2 flex items-center gap-4 p-4 cursor-pointer hover:cursor-pointer">
                    <div className="text-2xl font-bold text-blue-800 dark:text-yellow-800">
                        <img
                            className="max-w-[200px] object-cover object-center"
                            src={apiLogo}
                            loading="eager"
                            placeholder="blur"
                            alt="Logo"
                        />
                    </div>
                </div>
            </Link>
            <Link to="/osiris-api/" key="/osiris-api/">
                <div className="mb-2 flex items-center gap-4 p-4 cursor-pointer hover:cursor-pointer">
                    <DocumentTextIcon   alt="brand" className="h-8 w-8" />
                    <div className="font-bold text-xl text-gray-800 dark:text-gray-200">
                        {t('api-general')}
                    </div>
                </div>
            </Link>

            <Link to="/osiris-api/request-access" key="/osiris-api/request-access">
                <ListItem>
                    <ListItemPrefix>
                        <KeyIcon className="h-5 w-5" />
                    </ListItemPrefix>
                    {t('api-requestAccess')}
                </ListItem>
            </Link>

            <hr className="my-2 border-blue-gray-50" />

            <List>
                
                <Accordion
                    open={open === 2}
                    icon={
                        <ChevronDownIcon
                            strokeWidth={2.5}
                            className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? "rotate-180" : ""}`}
                        />
                    }
                >
                    <ListItem className="p-0" selected={open === 2}>
                        <AccordionHeader onClick={() => handleOpen(2)} className="border-b-0 p-3">
                            <ListItemPrefix>
                                <WrenchScrewdriverIcon className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography color="blue-gray" className="mr-auto font-normal">
                                {t('api-technical-title')}
                            </Typography>
                        </AccordionHeader>
                    </ListItem>
                    <AccordionBody className="py-1">
                        <List className="p-0">
                            <Link to="/osiris-api/technical-intro" key="/osiris-api/technical-intro">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                                            <span strokeWidth={2} className="h-3 w-5" />
                                            <BookOpenIcon strokeWidth={2} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-technical-intro-sidebar-title')}
                                </ListItem>
                            </Link>
                            <Link to="/osiris-api/technical-geoserver" key="/osiris-api/technical-geoserver">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                                            <span strokeWidth={2} className="h-3 w-5" />
                                            <GlobeAltIcon strokeWidth={2} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-technical-geoserver-title')}
                                </ListItem>
                            </Link>
                            <Link to="/osiris-api/technical-ogc" key="/osiris-api/technical-ogc">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                                            <span strokeWidth={2} className="h-3 w-5" />
                                            <CubeIcon strokeWidth={2} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-technical-ogc-title')}
                                </ListItem>
                            </Link>
                            <Link to="/osiris-api/technical-data-models" key="/osiris-api/technical-data-models">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                                            <span strokeWidth={2} className="h-3 w-5" />
                                            <CircleStackIcon strokeWidth={2} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-technical-datamodels-title')}
                                </ListItem>
                            </Link>
                        </List>
                    </AccordionBody>
                </Accordion>

                <Accordion
                    open={open === 1}
                    icon={
                        <ChevronDownIcon
                            strokeWidth={2.5}
                            className={`mx-auto h-4 w-4 transition-transform ${open === 1 ? "rotate-180" : ""}`}
                        />
                    }
                >
                    <ListItem className="p-0" selected={open === 1}>
                        <AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3">
                            <ListItemPrefix>
                                <AcademicCapIcon className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography color="blue-gray" className="mr-auto font-normal">
                                {t('api-tutorial-title')}
                            </Typography>
                        </AccordionHeader>
                    </ListItem>
                    <AccordionBody className="py-1">
                        <List className="p-0">
                            <Link to="/osiris-api/use-case-qgis" key="/osiris-api/use-case-qgis">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                            <span strokeWidth={2} className="h-3 w-5" />
                            <MapPinIcon strokeWidth={2} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-tutorial-qgis-title')}
                                </ListItem>
                            </Link>
                            <Link to="/osiris-api/use-case-endpoint" key="/osiris-api/use-case-endpoint">
                                <ListItem>
                                    <ListItemPrefix>
                                        <div className="flex flex-row items-center gap-4">
                                            <span strokeWidth={2} className="h-3 w-5" />
                                            <CodeBracketIcon strokeWidth={3} className="h-5 w-5" />
                                        </div>
                                    </ListItemPrefix>
                                    {t('api-tutorial-endpoint')}
                                </ListItem>
                            </Link>
                        </List>
                    </AccordionBody>
                </Accordion>
               
                <Link to="/osiris-api/terms-of-use" key="/osiris-api/terms-of-use">
                    <ListItem>
                        <ListItemPrefix>
                            <DocumentCheckIcon className="h-5 w-5" />
                        </ListItemPrefix>
                        {t('api-terms-of-use')}
                    </ListItem>
                </Link>
                
            </List>
        </Card>
    );
};
